import angular from 'angular';
import constants from 'app/constants';
import {
  orgDataService,
  ssDialogService
} from 'app/services';
import validator, { name as validatorName } from './unique-alert-recipient-email.validator.directive';
import controller from './edit-alert-recipient-dialog.controller';
import template from './edit-alert-recipient-dialog.html';

// Validation
import alertRecipientNameMessagesTpl from './messages/alert-recipient.name.messages.html';
import alertRecipientEmailMessagesTpl from './messages/alert-recipient.email.messages.html';

class dialogService {
  getOptions($event, { alertRecipient, addCallback }) {
    return {
      controller,
      controllerAs: 'editAlertRecipientDialogVM',
      locals: {
        alertRecipient,
        addCallback
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.vendorManagement.editAlertRecipientDialog', [
  constants,
  orgDataService,
  ssDialogService,
])
  .directive(validatorName, validator)
  .service('editAlertRecipientDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('alert-recipient.name.messages.html', alertRecipientNameMessagesTpl);
    $templateCache.put('alert-recipient.email.messages.html', alertRecipientEmailMessagesTpl);
  })
  .name;
